import { useContext } from 'react'

import { SavedQueryContext } from '../context'

export function useSavedQueryActions() {
  const { actions } = useContext(SavedQueryContext)
  return actions
}
